"use strict";

($dt => {

	const get_month_name = month_num => {
		const months = [
			'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'
		];
		return months[month_num - 1];
	};

	const is_time_in_minutes = (occ, time) => {
		const curr_datetime = new Date();
		curr_datetime.setTime(time);
		let found_match = false;
		switch (occ.recurrence_type) {
			case 'daily':
				found_match = true;
				break;
			case 'weekly':
				// get this day of week and compare with .weekdays
				let curr_day = curr_datetime.getDay() - 1;
				if (curr_day < 0) {
					curr_day = 6;
				}
				if (occ.weekdays.includes(curr_day)) {
					found_match = true;
				}
				break;
			case 'monthly':
				// get this cal day of month and compare with cal_days_in_month
				const cal_day = curr_datetime.getDate();
				if (occ.cal_days_in_month.includes(cal_day)) {
					found_match = true;
				} else if (occ.cal_days_in_month.includes(99)) {
					const last_day = new Date(curr_datetime.getFullYear(), curr_datetime.getMonth() + 1, 0);
					if (cal_day === last_day.getDate()) {
						found_match = true;
					}
				}
				break;
		}
		return found_match;
	};

	const get_hours_text_for_date = (hours, current_time) => {
		let todays_hours = '', single_found = false;
		hours.forEach(occ => {
			const [ start_date, end_date ] = [ new Date(occ.start_date), occ.end_date ? new Date(occ.end_date) : new Date(new Date(current_time).getFullYear() + 1, 0, 1) ];
			if (!single_found && current_time >= start_date && current_time <= end_date) {
				switch (occ.type) {
					case 'singular':
						todays_hours = occ.daily_time;
						single_found = true;
						break;
					case 'multiple':
					case 'special':
						if (is_time_in_minutes(occ, current_time)) {
							if (todays_hours.length === 0 || occ.type === 'special') {
								todays_hours = occ.daily_time;
							}
						}
						break;
				}
			}
		});
		return todays_hours.length > 0 ? todays_hours : 'Closed';
	};

	const create_calendar = (start_month, start_year, day_render) => {
		const cal = {
			current_month: start_month,
			current_year: start_year,
			day_render: day_render,
			Render: container => {
				container.innerHTML = '';
				container.appendChild(cal.CreateHeader());
				container.appendChild(cal.CreateDays());
			},
			CreateHeader: () => {
				const wrapper = document.createElement('div');
				wrapper.setAttribute('class', 'calendar-row calendar-header');
				const days = [ 'S', 'M', 'T', 'W', 'TH', 'F', 'S'];
				days.forEach(d => {
					const day_elem = document.createElement('div');
					day_elem.setAttribute('class', 'weekday');
					day_elem.innerHTML = d;
					wrapper.appendChild(day_elem);
				});
				return wrapper;
			},
			CreateDays: () => {
				const { current_location, hours } = $dt;
				const [ wrapper, display_days, todays_time ] = [
					document.createElement('div'),
					cal.GetEligibleCalendarDays(cal.current_year, cal.current_month),
					new Date().getTime() - (24 * 60 * 60 * 1000),
				];
				wrapper.setAttribute('class', 'calendar-row calendar-days');
				// Iterate through our calendar days and generate HTML
				display_days.forEach(cal_day => {
					const [ day_wrapper, day_label, day_inner_wrapper ] = [
						cal_day.month === cal.current_month ? document.createElement('a') : document.createElement('div'),
						document.createElement('span'),
						document.createElement('div')
					];

					day_label.setAttribute('class', 'day-number');
					if (cal_day.month === cal.current_month) {
						day_wrapper.setAttribute('href', '#');
						day_wrapper.addEventListener('click', e => {
							e.preventDefault();
						});
						day_wrapper.setAttribute('aria-label', get_month_name(cal.current_month) + ' ' + cal_day.day);
						day_wrapper.classList.add('month-day');
						day_label.innerHTML = cal_day.day;

						if (cal_day.time >= todays_time) {
							// Hours
							let is_closed = false;
							if (current_location && hours && hours[current_location]) {
								const hours_text = get_hours_text_for_date(hours[current_location], cal_day.time);
								is_closed = hours_text === 'Closed';
							}
							if (!is_closed) {
								day_wrapper.classList.add('active-day');
							}
						}
					}

					day_wrapper.appendChild(day_label);
					day_inner_wrapper.classList.add('day-inner-wrapper');
					day_wrapper.appendChild(day_inner_wrapper);

					if (cal_day.month === cal.current_month) {
						cal.day_render(cal_day.time, day_wrapper);
					}

					wrapper.appendChild(day_wrapper);
				});

				return wrapper;
			},
			GetCssClassesForDate: (year, month, day) => {
				const classes = [];
				cal.date_elems.forEach(date => {
					if (date.y === year && date.m === month && date.d === day && date.f()) {
						classes.push(date.c);
					}
				});
				return classes;
			},
			GetEligibleCalendarDays: (year, month) => {
				const display_days = [];

				const [ current_cal_month_date, last_date_of_month ] = [
					new Date(year, month - 1, 1),
					new Date(year, month, 0)
				];

				// Set the current date back based on the day of the week that the month starts
				current_cal_month_date.setDate(current_cal_month_date.getDate() - current_cal_month_date.getDay());

				// We always need complete weeks, so we'll use that as our check before finishing adding days
				let day_of_week = 0;
				while (day_of_week < 7) {
					display_days.push({
						month: current_cal_month_date.getMonth() + 1,
						day: current_cal_month_date.getDate(),
						year: current_cal_month_date.getFullYear(),
						time: current_cal_month_date.getTime()
					});

					// Increment Day
					current_cal_month_date.setDate(current_cal_month_date.getDate() + 1);
					day_of_week++;

					// Allow week to reset if the end of the month hasn't been reached
					if (day_of_week === 7 && current_cal_month_date.getTime() <= last_date_of_month.getTime()) {
						day_of_week = 0;
					}
				}

				return display_days;
			},
			NextMonth: month_increment => {
				if (!month_increment) {
					month_increment = 1;
				}
				cal.current_month += month_increment;
				if (cal.current_month > 12) {
					cal.current_month = 1;
					cal.current_year++;
				}
			},
			PreviousMonth: month_increment => {
				if (!month_increment) {
					month_increment = 1;
				}
				cal.current_month -= month_increment;
				if (cal.current_month < 1) {
					cal.current_month = 12;
					cal.current_year--;
				}
			}
		};
		return cal;
	};

	const controller = {

		Init: wrapper => {

			const this_cal = {
				wrapper: wrapper,
				elem: wrapper.querySelector('.calendar'),
				calendar: false,
				icons: [],
				current_datetime: new Date(),
				current_events: [],
				register_current_event: (ev, occ, time) => {
					this_cal.current_events.push({
						event: ev,
						occ: occ,
						time: time
					});
				},
				register_icon: (title, icon, id) => {
					let found = false;
					this_cal.icons.forEach(i => {
						if (i.icon === icon) {
							found = true;
						}
					});
					if (!found) {
						this_cal.icons.push({
							icon: icon,
							title: title,
							id: id
						});
					}
				},
				on_day_prerender: (time, day_wrapper) => {
					// when a given day renders, opportunity to do any tests and mods to day element
					if ($dt.events) {
						
						let found_match = false;
						$dt.events.forEach(event => {
							
							event.occurrences.forEach(occ => {
								const occ_start_date = occ.start_date ? new Date(occ.start_date) : new Date(-8640000000000000);
								const occ_end_date = occ.end_date ? new Date(occ.end_date) : new Date(8640000000000000);
								let event_match = false;
								
								if (time >= occ_start_date.getTime() && time <= occ_end_date.getTime()) {
									switch (occ.type) {
										case 'singular':
											event_match = true;
											break;
										case 'multiple':
											event_match = is_time_in_minutes(occ, time);
											break;
									}
								}

								if (event_match) {
									found_match = true;
									this_cal.register_current_event(event, occ, time);

									if (occ.icon) {
										day_wrapper.classList.add(occ.icon);
										this_cal.register_icon(event.title, occ.icon, event.id);
									}
								}
							});
						});

						if (found_match) {
							day_wrapper.classList.add('day-has-event');
						}
					}
				}
			};

			const [ start_year, start_month, start_day ] = [
				parseInt(this_cal.elem.getAttribute('data-start-year')),
				parseInt(this_cal.elem.getAttribute('data-start-month')),
				parseInt(this_cal.elem.getAttribute('data-start-day'))
			];

			this_cal.current_datetime = new Date(start_year, start_month - 1, start_day);

			const calendar = create_calendar(
				start_month,
				start_year,
				this_cal.on_day_prerender);

			this_cal.calendar = calendar;

			// Next/Previous Controls
			const rotators = wrapper.querySelectorAll('.month-rotate');
			rotators.forEach(r => {
				r.addEventListener('click', () => {
					if (r.getAttribute('data-direction') === 'previous') {
						calendar.PreviousMonth();
						this_cal.current_datetime.setMonth(calendar.current_month);
						this_cal.current_datetime.setDate(0);
					} else {
						calendar.NextMonth();
						this_cal.current_datetime.setMonth(calendar.current_month - 1);
						this_cal.current_datetime.setDate(1);
					}
					controller.Refresh(this_cal);
				});
			});

			// Month clickers
			const [ extra_month_labels ] = [
				wrapper.querySelectorAll('.month-extra')
			];
			extra_month_labels.forEach(month_elem => {
				month_elem.addEventListener('click', () => {
					const month_increment = parseInt(month_elem.getAttribute('data-month-plus'));
					calendar.NextMonth(month_increment);
					this_cal.current_datetime.setMonth(calendar.current_month - 1);
					this_cal.current_datetime.setDate(1);
					controller.Refresh(this_cal);
				});
			});

			// Render initial
			calendar.Render(this_cal.elem);
			controller.RenderLegend(this_cal);
			controller.RenderDayView(this_cal);
			controller.UpdateSelectedDay(this_cal, false);

			// Set day events
			controller.AddDayClickEvents(this_cal);

			// Search
			controller.ConfigureSearch(this_cal);

			// Arrow keys
			controller.ConfigureArrowKeys(this_cal);

			return calendar;
		},

		ConfigureArrowKeys: this_cal => {
			const { calendar } = this_cal;
			const allowed_keys = [
				'ArrowRight', 'ArrowLeft', 's', 'S'
			];
			document.addEventListener('keydown', e => {
				if (allowed_keys.includes(e.key)) {
					// Check path
					let found = false, i = 0;
					const path = e.composedPath ? e.composedPath() : e.path;
					while (!found && path && i < path.length) {
						if (path[i] === this_cal.elem) {
							found = true;
						}
						i++;
					}
					
					if (found) {
						e.preventDefault();
						switch (e.key) {
							case 'ArrowLeft':
								calendar.PreviousMonth();
								this_cal.current_datetime.setMonth(calendar.current_month);
								this_cal.current_datetime.setDate(0);
								controller.Refresh(this_cal);
								break;
							case 'ArrowRight':
								calendar.NextMonth();
								this_cal.current_datetime.setMonth(calendar.current_month - 1);
								this_cal.current_datetime.setDate(1);
								controller.Refresh(this_cal);
								break;
							case 's':
							case 'S':
								const links = this_cal.wrapper.querySelectorAll('a');
								if (links && links.length > 0) {
									const last_link = links[links.length - 1];
									last_link.focus();
								}
								break;
						}
					}
				}
			});
		},

		ConfigureSearch: this_cal => {
			const { wrapper } = this_cal;
			const [ btn_search, btn_reset, results_wrapper, results_list_elem, no_results_elem ] = [
				wrapper.querySelector('.btn-event-search'),
				wrapper.querySelector('.btn-event-reset'),
				wrapper.querySelector('.calender-search-results'),
				wrapper.querySelector('.calender-search-results .results-list'),
				wrapper.querySelector('.no-results-found')
			];

			const [ text_elem, date_elem, age_elem ] = [
				wrapper.querySelector('[name="event_search_text"]'),
				wrapper.querySelector('[name="event_search_month"]'),
				wrapper.querySelector('[name="event_search_ages"]')
			];

			let [ search_keywords_text, search_date_text, search_age_text ] = [
				'', '', ''
			];

			let [ keywords, date, age ] = [
				false, false, false
			];

			const do_search = () => {
				const events = [];
				results_list_elem.innerHTML = '';
				no_results_elem.classList.remove('active');

				// Search
				if ($dt.events) {
					search_keywords_text = text_elem.value;
					search_date_text = date_elem.value;
					search_age_text = age_elem.value;

					keywords = search_keywords_text && search_keywords_text.length > 0 ? search_keywords_text.trim().toLowerCase() : false;
					date = search_date_text && search_date_text.length > 0 ? new Date(search_date_text) : false;
					age = search_age_text && search_age_text.length > 0 ? search_age_text : false;

					$dt.events.forEach(ev => {
						let event_matches = true;

						// Event Keywords
						if (keywords) {
							let has_one_keyword = false;
							const searchable_text = (ev.title + ' ' + ev.short_description).toLowerCase();
							const keywords_list = keywords.split(/\s+/);
							keywords_list.forEach(kw => {
								if (searchable_text.includes(kw)) {
									has_one_keyword = true;
								}
							});
							if (!has_one_keyword) {
								event_matches = false;
							}
						}

						// Event Ages
						if (event_matches && age) {
							if (!ev.age_groups.includes(age)) {
								event_matches = false;
							}
						}

						// Event Date Range
						if (event_matches) {
							let [ min_date, max_date, today_date ] = [
								date ? new Date(date.getFullYear(), date.getMonth(), 1) : false,
								date ? new Date(date.getFullYear(), date.getMonth() + 1, 0) : false,
								new Date()
							];

							if (!min_date) {
								min_date = today_date;
							} else {
								if (min_date.getTime() < today_date.getTime()) {
									min_date.setDate(today_date.getDate());
								}
							}
							min_date.setHours(0, 0, 0, 0);

							if (max_date) {
								max_date.setHours(23, 59, 59, 999);
							}

							const [ min_time, max_time ] = [
								min_date.getTime(),
								max_date ? max_date.getTime() : false
							];

							let occurrence_match = false;
							ev.occurrences.forEach(occ => {
								if (!occurrence_match) {
									const [ event_start_date, event_end_date ] = [
										occ.start_date ? new Date(occ.start_date) : false,
										occ.end_date ? new Date(occ.end_date) : false
									];

									const [ event_start_time, event_end_time ] = [
										event_start_date ? event_start_date.getTime() : false,
										event_end_date ? event_end_date.getTime() : false
									];

									let this_occurrence_matches = true;
									if (event_start_time !== false && max_time !== false && event_start_time && event_start_time > max_time) {
										this_occurrence_matches = false;
									}

									if (event_end_time !== false && event_end_time < min_time) {
										this_occurrence_matches = false;
									}

									if (this_occurrence_matches) {
										occurrence_match = true;
									}
								}
							});

							if (!occurrence_match) {
								event_matches = false;
							}
						}

						if (event_matches) {
							events.push(ev);
						}
					});
				}

				if (events.length === 0) {
					no_results_elem.classList.add('active');
				} else {
					// Render Results
					events.forEach(ev => {
						const result_elem = document.createElement('div');
						result_elem.classList.add('search-result');

						result_elem.innerHTML = `
							<div class="result-thumb"><a href="${ev.detail_href}">${ev.thumbnail}</a></div>
							<div class="result-text"><h2><a href="${ev.detail_href}">${ev.title}</a></h2>
								<span class="result-time">${ev.timespan_summary}</span>
								<span class="result-desc">${ev.short_description}</span>
							</div>
							<div class="result-button"><a href="${ev.detail_href}"><span class="link-text">${(ev.registration_required ? 'Register' : 'Learn more')}</span></a></div>`;

						results_list_elem.appendChild(result_elem);
					});
				}
			};

			btn_search.addEventListener('click', do_search);

			btn_reset.addEventListener('click', () => {
				text_elem.value = '';
				date_elem.value = '';
				age_elem.value = '';
				results_list_elem.innerHTML = '';
				results_wrapper.classList.remove('active');
				no_results_elem.classList.remove('active');
			});

			text_elem.addEventListener('keyup', e => {
				if (e.which && e.which === 13) {
					e.preventDefault();
					do_search();
				}
			});
		},

		AddDayClickEvents: this_cal => {
			const { wrapper, calendar } = this_cal;
			const days = wrapper.querySelectorAll('.calendar-days > a');
			days.forEach(day => {
				day.addEventListener('click', () => {
					day.focus();
				});
				day.addEventListener('focus', () => {
					const day_val = day.querySelector('.day-number').innerHTML;
					if (day_val && day_val.length > 0) {
						const day_num = parseInt(day_val);
						this_cal.current_datetime.setFullYear(calendar.current_year);
						this_cal.current_datetime.setMonth(calendar.current_month - 1);
						this_cal.current_datetime.setDate(day_num);
						controller.RenderDayView(this_cal);
						controller.UpdateSelectedDay(this_cal, false);
					}
				});
			});
		},

		UpdateSelectedDay: (this_cal, with_focus) => {
			const { wrapper, current_datetime } = this_cal;
			const days = wrapper.querySelectorAll('.calendar-days > a');
			days.forEach(day => {
				const day_val = day.querySelector('.day-number').innerHTML;
				let is_selected = false;
				if (day_val && day_val.length > 0) {
					const day_num = parseInt(day_val);
					if (day_num === current_datetime.getDate()) {
						is_selected = true;
					}
				}

				if (!is_selected) {
					day.classList.remove('selected-day');
				} else {
					day.classList.add('selected-day');
					if (typeof(with_focus) !== 'undefined' && with_focus) {
						day.focus();
					}
				}
			});
		},

		RenderLegend: this_cal => {
			const legend_elem = this_cal.wrapper.querySelector('.event-legend');
			legend_elem.innerHTML = '';
			this_cal.icons.forEach(icon => {
				const elem = document.createElement('span');
				elem.classList.add('event-legend-icon');
				elem.classList.add(icon.icon);
				elem.innerHTML = icon.title;
				legend_elem.appendChild(elem);
			});
		},

		RenderDayView: this_cal => {
			const { wrapper, current_datetime } = this_cal;
			const current_time = current_datetime.getTime();

			// Date & Hours
			const day_details_elem = wrapper.querySelector('.day-details');
			const [ title_elem, hours_elem ] = [ day_details_elem.querySelector('.date-title'), day_details_elem.querySelector('.location-hours') ];

			// Date
			title_elem.innerHTML = controller.GetDayName(current_datetime.getDay()) + ',<br/>' + controller.GetMonthName(current_datetime.getMonth() + 1) + ' ' + current_datetime.getDate();

			// Hours
			let is_closed = false;
			const { current_location, hours } = $dt;
			if (current_location && hours && hours[current_location]) {
				const hours_text = get_hours_text_for_date(hours[current_location], current_time);
				hours_elem.innerHTML = hours_text;
				if (hours_text === 'Closed') {
					is_closed = true;
				}
			}

			// Event List
			const list_elem = wrapper.querySelector('.event-list');
			list_elem.innerHTML = '';
			if (!is_closed) {
				this_cal.current_events.forEach(ev => {
					const { event, occ, time } = ev;
					if (time >= this_cal.current_datetime.getTime() && time <= this_cal.current_datetime.getTime()) {
						const [ event_elem, info_elem, button_elem ] = [ document.createElement('div'), document.createElement('div'), document.createElement('div') ];
						event_elem.classList.add('event-list-item');

						info_elem.classList.add('event-item-text');
						info_elem.innerHTML = '<span class="event-title">' + event.title + '</span><span class="event-time">' + occ.daily_time + '</span>';
						event_elem.appendChild(info_elem);

						button_elem.classList.add('event-item-button');
						button_elem.innerHTML = '<a href="' + event.detail_href + '"><span class="link-text">' + (event.registration_required ? 'Register' : 'Learn more') + '</span></a>';
						event_elem.appendChild(button_elem);

						list_elem.appendChild(event_elem);
					}
				});
			}
		},

		Refresh: this_cal => {

			const { calendar, wrapper } = this_cal;
			
			this_cal.icons = [];
			this_cal.current_events = [];
			calendar.Render(wrapper.querySelector('.calendar'));
			controller.RenderLegend(this_cal);
			controller.RenderDayView(this_cal);
			controller.UpdateSelectedDay(this_cal, true);
			
			const [ month_label, extra_month_labels ] = [
				wrapper.querySelector('.month-current'),
				wrapper.querySelectorAll('.month-extra')
			];

			month_label.innerHTML = controller.GetShortMonthName(calendar.current_month) + ' ' + calendar.current_year;
			const month_ahead_date = new Date();
			month_ahead_date.setFullYear(calendar.current_year);
			month_ahead_date.setMonth(calendar.current_month - 1);
			extra_month_labels.forEach(elem => {
				month_ahead_date.setMonth(month_ahead_date.getMonth() + 1);
				elem.setAttribute('data-month-target', month_ahead_date.getMonth());
				elem.innerHTML = controller.GetShortMonthName(month_ahead_date.getMonth() + 1);
			});

			// Set day events
			controller.AddDayClickEvents(this_cal);
		},

		GetShortMonthName: month_num => {
			const months = [
				'Jan', 'Feb', 'March', 'April', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'
			];
			return months[month_num - 1];
		},

		GetMonthName: month_num => {
			return get_month_name(month_num);
		},

		GetDayName: day_num => {
			const days = [
				'Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'
			];
			return days[day_num];
		}
	};

	$dt.Calendar = controller;
})(window.d3_wp_themejs);
